<template>
    <div
        class="roadmap-edit-header"
        v-if="roadmapIn">
        <h3 class="title order-1 order-sm-0">
            {{ roadmapIn.title }}
        </h3>

        <div
            class="roadmap-edit-tools order-0 order-sm-1"
            v-if="roadmapIn">
            <div class="context-nav context-nav-main-roadmap">
                <b-button
                    class="btn-edit btn-edit-roadmap-title"
                    v-b-modal="'roadmap-title-edit-modal'"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('roadmap.edit_title')">
                </b-button>
            </div>
        </div>

        <design-2021-roadmap-edit-title-modal-component
            :roadmap-in="roadmapIn"></design-2021-roadmap-edit-title-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-roadmap-edit-title-component',
    props: ['roadmapIn'],
};
</script>

<style scoped lang="scss">
.roadmap-edit-header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    flex: 1 0 100%;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .title {
        font-weight: $font-weight-bold;
        margin-bottom: 0;
    }

    .roadmap-edit-tools {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 1 0 100%;
    }

    &:hover {
        cursor: pointer;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .roadmap-edit-header {
        flex-wrap: nowrap;

        .title {
            width: calc(100% - 95px);
        }

        .roadmap-edit-tools {
            flex: 0 1 auto;
            margin-left: auto;
            align-self: baseline;
        }
    }
}
</style>
